<template>
  <div
    ref="crumbContent"
    class="crumb list-crumb"
  >
    <div v-if="crumbTitle">
      <span class="crumb-title">{{ crumbTitle }}</span>
    </div>
    <div v-else>
      <div
        v-if="crumbLen > 1"
        class="crumb-item go-back"
        @click="goBack(crumbLen - 2)"
      >
        <span
          :title="$t('返回')"
        >
          {{ $t('返回') }}
        </span><span class="separator" />
      </div>
      <ul
        ref="crumbList"
        class="crumb-list"
      >
        <template v-if="previousNavLen">
          <li
            v-for="(item, index) in previousNavData"
            :key="'PreviousNav' + index"
            class="previous-nav"
          >
            <span
              class="crumb-item"
              :title="item"
              @click="goBack(index)"
            >
              {{ item }}
            </span>
            <span class="crumb-arrow">/</span>
          </li>
        </template>
        <!-- 只有中间有值时才显示 -->
        <li
          v-show="moreNav && moreNavData.length > 0"
          class="more-nav"
        >
          <i
            class="more-nav-btn"
            @click="clickMoreBtn"
          >
            <svg class="ellipsis">
              <use xlink:href="#ellipsis" />
            </svg>
            <div
              v-show="moreNavList"
              class="more-nav-list"
              @mouseleave="moreNavList = false"
            >
              <li
                v-for="(item, index) in moreNavData"
                :key="'moreNav' + index"
              >
                <span
                  class="crumb-item more-nav-item"
                  :title="item"
                  @click.stop="goBack(index + previousNavLen)"
                >
                  {{ item }}
                </span>
              </li>
            </div>
          </i>
          <span class="crumb-arrow">/</span>
        </li>
        <template v-if="crumbLen">
          <li
            v-for="(item, index) in newNavData"
            :key="'newNav' + index"
            class="tial-nav"
          >
            <span
              class="crumb-item"
              :title="item"
              :class="getNavItemCls(index)"
              @click="goBack(index + previousNavLen + moreNavLen)"
            >
              {{ item }}
            </span>
            <span class="crumb-arrow">/</span>
          </li>
        </template>
      </ul>
    </div>
  </div>
</template>
<script>
// 只展示2个字的宽度
const ELLIPSIS_NAV_WIDTH = 58
// 字体大小
const NAV_FONT_SIZE = 12
// 最后/宽度
const NAV_AFTER_WIDTH = 18
// 正常的...的宽度
const NAV_ITEM_MAX_WIDTH = 190

export default {
  props: {
    crumbData: {
      type: Array,
      default() {
        return []
      },
    },
    /**
     * @description 最后要展示的元素数量
     */
  },
  data() {
    return {
      crumbTitle: '',
      previousNavNum: 2,
      // 最后要展示的元素数量
      navTailLength: 4,
      moreNav: false,
      moreNavList: false,
      previousNavData: [],
      moreNavData: [],
      newNavData: [],
      ellipsisNavCount: 0,
    }
  },
  computed: {
    crumbLen() {
      return this.crumbData.length
    },
    moreNavLen() {
      return this.moreNavData.length
    },
    previousNavLen() {
      return this.previousNavData.length
    },
    newNavDataLen() {
      return this.newNavData.length
    },
  },
  watch: {
    crumbData(nv, ov) {
      if (nv !== ov) {
        Object.assign(this.$data, this.$options.data())
        this.renderNav()
      }
    },
    moreNavList(val) {
      if (val) {
        document.addEventListener('click', this.blankHander)
      } else {
        document.removeEventListener('click', this.blankHander)
      }
    },
  },
  mounted() {
    this.renderNav()
  },
  methods: {
    clickMoreBtn() {
      this.moreNavList = true
    },
    goBack(index) {
      if (this.crumbLen === index + 1) return
      const param = {
        path: this.crumbData.slice(0, index + 1).join('/'),
        index,
      }
      this.$emit('crumbJump', param)
    },
    async renderNav() {
      // 初始化
      this.moreNav = false
      this.ellipsisNavCount = 0
      /**
       * 1、给 PreviousNav 赋值
       * 2、超过6个肯定隐藏中间部分
       * 3、不超过6个的从最后一个开始隐藏，最多隐藏4个
       */
      // 如果少于 previousNavNum 数量则直接放到 后面
      if (this.crumbData.length <= this.previousNavNum) {
        this.newNavData = this.crumbData
        return
      }

      this.previousNavData = this.crumbData.slice(0, this.previousNavNum)
      if (this.crumbLen > this.previousNavNum + this.navTailLength) {
        // 2、给 moreNavData 和 newNavData 复制
        this.previousNavData = this.crumbData.slice(0, this.previousNavNum)
        const mid = this.crumbLen - this.navTailLength
        this.moreNavData = this.crumbData.slice(this.previousNavNum, mid)
        this.newNavData = this.crumbData.slice(mid)
        this.moreNav = true
      } else {
        // 去当时列表宽度
        const width = await this.getWidth()
        const lastNav = this.crumbData.slice(this.previousNavNum)
        for (let i = lastNav.length - 1; i >= 0; i -= 1) {
          // 下一个元素不省略的宽度
          const nextWidth = this.computeNewNavWidth(lastNav, lastNav.length - 1 - i)
          if (width.listWidth + width.backAreaWidth + nextWidth >= width.contentWidth) {
            this.ellipsisNavCount += 1
          }
        }

        this.newNavData = this.crumbData.slice(this.previousNavNum)
      }
    },
    getWidth() {
      return new Promise((resolve) => {
        this.$nextTick(() => {
          const contentWidth = this.$refs.crumbContent.offsetWidth
          const listWidth = this.$refs.crumbList.offsetWidth
          const backAreaWidth = 60
          const width = {
            contentWidth,
            listWidth,
            backAreaWidth,
          }
          resolve(width)
        })
      })
    },
    blankHander(e) {
      e.stopPropagation()
      const event = e || window.event
      const target = event.target || event.srcElement
      if (
        target.getAttribute('class')
        && target.getAttribute('class').indexOf('more-nav-list') === -1
        && e.target.getAttribute('class').indexOf('more-nav-btn') === -1
      ) {
        this.moreNavList = false
      }
    },
    /**
     * 计算 Nav Item 的 class
     * * */
    getNavItemCls(index) {
      let crumbNavItem = false

      if (index > this.newNavDataLen - this.ellipsisNavCount - 1) {
        crumbNavItem = true
      }
      return {
        'last-item': this.newNavDataLen - 1 === index,
        'crumb-nav-item': this.moreNav || crumbNavItem,
      }
    },
    /**
     * 计算 NewNav 要占据的宽度
     * 计算规则 ellipsis 的宽度是 ELLIPSIS_NAV_WIDTH * 隐藏的元素 + 字数 * fontsize + 后面斜杠的宽度
     * * */
    computeNewNavWidth(newNavs, tail = 0) {
      let width = tail * ELLIPSIS_NAV_WIDTH
      for (let index = newNavs.length - tail - 1; index >= 0; index -= 1) {
        const curNav = newNavs[index]
        // font-size * 文字宽度忽略半角字符 + 尾部元素宽度
        if (curNav.length * NAV_FONT_SIZE > 190) {
          width += NAV_ITEM_MAX_WIDTH + NAV_AFTER_WIDTH
        } else {
          width += curNav.length * NAV_FONT_SIZE + NAV_AFTER_WIDTH
        }
      }
      return width
    },
  },
}
</script>

<style lang="less" scoped>
.crumb {
  position: relative;
  height: 24px;
  line-height: 24px;
  display: inline-block;
  white-space: nowrap;
  width: 100%;
  &::after {
    content: '';
    width: 0;
    height: 0;
    display: table;
    visibility: none;
    clear: both;
  }
  .crumb-title {
    font-size: 12px;
    color: #637282;
    position: absolute;
    overflow: hidden;
    width: 100%;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  &.list-crumb {
    .go-back,
    .crumb-list,
    .crumb-list > li {
      display: inline-block;
      float: left;
    }
    .more-nav {
      position: relative;
      .more-nav-btn {
        display: inline-block;
        color: #7f7f7f;
        cursor: pointer;
        .ellipsis {
          margin-top: 2px;
          width: 20px;
          height: 20px;
        }
      }
      .more-nav-list {
        position: absolute;
        z-index: 10;
        top: 20px;
        left: 0px;
        max-width: 600px;
        max-height: 500px;
        padding: 10px 0;
        overflow: auto;
        background: #ffffff;
        box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.15);
        border-radius: 2px;
        li {
          height: 36px;
          line-height: 36px;
        }
        li:hover {
          background-color: #f0f2f6;
        }
        .more-nav-item {
          width: 100%;
          padding: 0 12px;
          font-size: 13px;
          color: #282e3d;
          white-space: nowrap;
          cursor: pointer;
          box-sizing: border-box;
        }
      }
    }
    .crumb-item {
      float: left;
      display: inline-block;
      max-width: 190px;
      font-size: 12px;
      color: #637282;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      cursor: pointer;
      span {
        font-size: 12px;
      }
      &.crumb-nav-item {
        max-width: 40px;
      }
      &.go-back {
        color: #1b2733;
      }
      &.last-item {
        color: #1b2733;
        cursor: default;
        & + .crumb-arrow {
          display: none;
        }
      }
      &:hover {
        text-decoration: underline;
      }
    }
    .crumb-arrow {
      margin: 0 6px;
      float: right;
      color: #637282;
    }
    .separator {
      position: relative;
      top: 1px;
      display: inline-block;
      width: 1px;
      height: 12px;
      background-color: #929ca9;
      margin: 0 8px;
    }
  }
  &.search-crumb {
    .go-back,
    .search-result {
      float: left;
      height: 35px;
      line-height: 35px;
      font-size: 14px;
    }
    .go-back {
      color: #2285ff;
      span.pre {
        display: inline-block;
        cursor: pointer;
        padding-right: 8px;
      }
      span.nav-gap {
        display: inline-block;
      }
    }
    .search-result {
      margin-left: 8px;
      color: #7f7f7f;
      .strong {
        color: #343434;
        max-width: 235px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        display: inline-block;
        vertical-align: bottom;
        font-weight: bold;
      }
    }
  }
}
</style>
